

















import Vue from 'vue';

export default Vue.extend({
  props: {
    sortField: {
      type: String,
      required: true
    },
    sortBy: {
      type: String,
      required: true
    },
    sortDir: {
      type: Number,
      required: true
    }
  }
});
